import {Text} from '@/components-v2/atoms'
import {TextInput} from '@/components-v2/molecules'
import {useRewardDiscount} from '@/containers/Promotions/components/PromotionsConditions/Rewards/useRewardDiscount'

/** v2 discount value input (percentage or cash), plus the max discount value for percentage discounts. */
export const RewardDiscount = ({
  promotionCondition,
  textAfterInput = '% off.',
  showDynamicPlaceholder = false,
  discountType,
  rewardIndex = 0,
}) => {
  const {
    currencyCode,
    isCashDiscount,
    isPercentageDiscount,
    placeholderText,
    discountValue,
    maxDiscountValue,
    errorText,
    maxDiscountError,
    handleDiscountChange,
    handleMaxDiscountChange,
  } = useRewardDiscount({promotionCondition, showDynamicPlaceholder, discountType, rewardIndex})

  return (
    <>
      {isCashDiscount && <Text>{currencyCode}</Text>}
      <div className="w-[150px]">
        <TextInput
          type="number"
          value={discountValue}
          placeholderText={placeholderText}
          onUpdate={handleDiscountChange}
          error={errorText || undefined}
        />
      </div>
      {!isCashDiscount && <Text>{textAfterInput}</Text>}
      {isPercentageDiscount && (
        <>
          <Text>Max Discount Value $</Text>
          <div className="w-[150px]">
            <TextInput
              type="number"
              min={0}
              value={maxDiscountValue}
              onUpdate={handleMaxDiscountChange}
              error={maxDiscountError || undefined}
            />
          </div>
        </>
      )}
    </>
  )
}
